export default __webpack_public_path__ + "static/media/jangwon_nft_5.6632e920.svg";